import { APP_PDC_URL } from "../../../config";

import { createHttpHeaderWithAuthorization } from "../../services/http-header";

import { callWithRetry } from "../../services/callWithRetry";
import { overflowNotificationConstants } from "../overflowNotification";

export const surveysConstants = {
  CREATE_SURVEY_ASK_ERROR: "CREATE_SURVEY_ASK_ERROR",
  CREATE_SURVEY_ASK_START: "CREATE_SURVEY_ASK_START",
  CREATE_SURVEY_ASK_SUCCESS: "CREATE_SURVEY_ASK_SUCCESS",

  REMIND_SURVEY_ASK_ERROR: "REMIND_SURVEY_ASK_ERROR",
  REMIND_SURVEY_ASK_START: "REMIND_SURVEY_ASK_START",
  REMIND_SURVEY_ASK_SUCCESS: "REMIND_SURVEY_ASK_SUCCESS",

  VIEWED_SURVEY_ASK_CHANGE_ERROR: "VIEWED_SURVEY_ASK_CHANGE_ERROR",
  VIEWED_SURVEY_ASK_CHANGE_START: "VIEWED_SURVEY_ASK_CHANGE_START",
  VIEWED_SURVEY_ASK_CHANGE_SUCCESS: "VIEWED_SURVEY_ASK_CHANGE_SUCCESS",

  GET_CATEGORY_ASK_ERROR: "GET_CATEGORY_ASK_ERROR",
  GET_CATEGORY_ASK_START: "GET_CATEGORY_ASK_START",
  GET_CATEGORY_ASK_SUCCESS: "GET_CATEGORY_ASK_SUCCESS"
};

export function remindSurveyAsk(surveyId) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;

    const user = getState().user;
    
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "PUT",
        url:
          APP_PDC_URL + "/api/v1/answers/" + surveyId + "/remind",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: {}
      };

      dispatch({
        type: surveysConstants.REMIND_SURVEY_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: overflowNotificationConstants.SHOW_OVERFLOW,
              payload: {
                type: "success",
                title: "OK",
                message: user?.profile?.language === "es-ES" ? "Recordatorio enviado con éxito" : "Richiesta sollecitata con successo"
              }
            });
            dispatch({
              type: surveysConstants.REMIND_SURVEY_ASK_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: surveysConstants.REMIND_SURVEY_ASK_ERROR,
              error: result
            });
            reject(result);
          }
        })
        .catch(response => {
          dispatch({
            type: surveysConstants.REMIND_SURVEY_ASK_ERROR,
            error: response.toString()
          });
          reject();
        });
    });
  };
}

export function changeViewedSurveyAsk(surveyId,
  viewed) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;
    const myType = main.myType;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "PATCH",
        url:
          APP_PDC_URL + "/api/v1/answers/" + surveyId + "/viewed",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: {
          itemId: myType === "STUDIO" ? accountantUuidSelected : companyUuidSelected,
          isViewed: viewed
        }
      };

      dispatch({
        type: surveysConstants.VIEWED_SURVEY_ASK_CHANGE_START,
        payload: { id: surveyId, viewed: viewed, accountant: myType === "STUDIO" }
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: surveysConstants.VIEWED_SURVEY_ASK_CHANGE_SUCCESS,
              payload: { id: surveyId, viewed: viewed, accountant: myType === "STUDIO" }
            });
          } else {
            dispatch({
              type: surveysConstants.VIEWED_SURVEY_ASK_CHANGE_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: surveysConstants.VIEWED_SURVEY_ASK_CHANGE_ERROR,
            error: response.toString()
          });
          reject();
        });
    });
  };
}

export function createSurveyAsk(bodyRequest) {

  return (dispatch, getState) => {

    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    const companyUuidSelected = getState().main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: APP_PDC_URL + "/api/v1/surveys",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: bodyRequest
      };

      dispatch({
        type: surveysConstants.CREATE_SURVEY_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: surveysConstants.CREATE_SURVEY_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: surveysConstants.CREATE_SURVEY_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: surveysConstants.CREATE_SURVEY_ASK_ERROR,
            error: response.toString()
          });
          reject();
        });
    });
  };
}

export function getCategoryAsk() {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: APP_PDC_URL + "/api/v1/ask/categories",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: surveysConstants.GET_CATEGORY_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: surveysConstants.GET_CATEGORY_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: surveysConstants.GET_CATEGORY_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: surveysConstants.GET_CATEGORY_ASK_ERROR,
            error: response.toString()
          });
          reject();
        });
    });
  };
}
